import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "up-arrow_jax_302fc60b682141d0aa3b002f1a9c527f",
  "use": "up-arrow_jax_302fc60b682141d0aa3b002f1a9c527f-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"up-arrow_jax_302fc60b682141d0aa3b002f1a9c527f\">\n<path d=\"M8.68737 6.48963L5.177 2.97926L1.66663 6.48963\" stroke=\"#A9AFB8\" stroke-width=\"1.4\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol